import { Row, Col, Image } from "antd";

export const RoshanneWijesuriyaBuilding = () => {
  return (
    <div style={{ padding: "10px" }}>
      <div style={{ textAlign: "center" }}>
        <h1 id="roshanne-wijesuriya-building">Roshanne Wijesuriya Building</h1>
      </div>
      <Row>
        <Col xs={24} sm={24} md={24}>
          <p>
            Roshanne Wijesuriya A-Level Building – A Lasting Tribute As part of
            Bishop’s College’s 150th anniversary celebrations on January 21, a
            new A-Level building—funded through a generous Rs. 270 million
            donation from Nahil Wijesuriya—was officially opened. The
            state-of-the-art facility, named the Roshanne Wijesuriya Building in
            memory of his late wife, stands as a testament to his family's
            enduring commitment to education and community. At the ceremony,
            Nahil’s son, Vijitha Wijesuriya, delivered a heartfelt speech
            thanking the school for allowing them to honour Roshanne’s memory
            through this lasting contribution.
          </p>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "100%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/70-roshanne-wijesuriya-building/dedication-to-roshanne-wijesuriya.jpeg"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
              <p>
                <small>
                  Dedication to Roshanne Wijesuriya, Nahil's late wife
                </small>
              </p>
            </div>
          </div>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "100%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/70-roshanne-wijesuriya-building/letter-from-bishops-college-donation.jpg"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
              <p>
                <small>
                  Letter from Chameli - Principle of Bishops College to Nahil
                </small>
              </p>
            </div>
          </div>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "100%",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/70-roshanne-wijesuriya-building/gift-received-from-bishops-college.jpeg"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
              <p>
                <small>Gift from Bishops College to Nahil Wijesuriya</small>
              </p>
            </div>
          </div>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "400px",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/70-roshanne-wijesuriya-building/news-wire-tweet-donation-bishops-college.jpg"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
              <p>
                <small>News Wire - Tweet</small>
              </p>
            </div>
          </div>
          <div
            style={{
              float: "left",
              margin: "10px",
            }}
          >
            <Image
              style={{
                maxWidth: "400px",
              }}
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/70-roshanne-wijesuriya-building/bishop-college-award.jpeg"
              }
            />
            <div style={{ textAlign: "center", maxWidth: "400px" }}>
              <p>
                <small>Gift from Bishops College to Nahil Wijesuriya</small>
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
